"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.inList = exports.CompatibleInListConfig = void 0;
const lodash_1 = __importDefault(require("lodash"));
const common_1 = require("@finley-technologies/common");
const utils_1 = require("./utils");
class CompatibleInListConfig {
    constructor(config) {
        this.config = config;
        // Private instance properties allow typescript to ensure that an instance of
        // this class is being used.
        this.isCompatible = true;
        this.ensureCompatibility = (loanTape) => {
            const { field, type, list } = this.config;
            const invalidListValue = list.find((value) => typeof value !== type);
            (0, common_1.finleyAssert)(!invalidListValue, `list value ${invalidListValue} has invalid type ${typeof invalidListValue}. Expected type ${type}`);
            const invalidRecord = lodash_1.default.find(loanTape, (record) => {
                const value = (0, utils_1.getFieldValue)({ loanTape: record, field });
                return !lodash_1.default.isNil(value) && typeof value !== type;
            });
            (0, common_1.finleyAssert)(!invalidRecord, (0, utils_1.getInvalidFieldTypeMessage)({ invalidRecord, field, type }));
            (0, common_1.finleyAssert)(this.isCompatible, 'Config must be compatible with loanTape');
        };
        this.operation = config.operation;
    }
}
exports.CompatibleInListConfig = CompatibleInListConfig;
CompatibleInListConfig.create = (config, loanTape) => {
    const obj = new CompatibleInListConfig(config);
    obj.ensureCompatibility(loanTape);
    return obj;
};
/*
 * Selects all loanTapes where the value of a field is
 * contained in a list of values
 *
 * example config:
 * {
 *    field: 'industry',
 *    type: 'string',
 *    operator: 'inList',
 *    list: ['hotels', 'restaurants', 'leisure'],
 * }
 *
 */
const inList = ({ config: { field, list, operation }, }) => (loanTapeRecords) => {
    const targetKeySet = list.reduce((keySet, value) => keySet.add((0, utils_1.toLowerIfString)(value)), new Set());
    const filteredTape = loanTapeRecords.filter((loanTape) => {
        const lowerCaseValue = (0, utils_1.toLowerIfString)((0, utils_1.getFieldValue)({ field, loanTape }));
        const isInList = targetKeySet.has(lowerCaseValue);
        return operation === 'inList' ? isInList : !isInList;
    });
    return filteredTape;
};
exports.inList = inList;
//# sourceMappingURL=inList.js.map